import { FILE_MANAGEMENT_COLUMN_ORDER } from '@rd-web-markets/market/dist/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
const FolderAndFileTableHeading = () => {
  const {
    t
  } = useTranslation();
  const renderColumn = columnName => {
    switch (columnName) {
      case 'folderIcon':
        return /*#__PURE__*/React.createElement("th", {
          key: "column-".concat(columnName)
        });
      case 'createdAt':
        return /*#__PURE__*/React.createElement("th", {
          key: "column-".concat(columnName)
        }, t('Date'));
      case 'name':
        return /*#__PURE__*/React.createElement("th", {
          key: "column-".concat(columnName)
        }, t('Name'));
      case 'notes':
        return /*#__PURE__*/React.createElement("th", {
          key: "column-".concat(columnName)
        }, t('Notes'));
      case 'uploadedBy':
        return /*#__PURE__*/React.createElement("th", {
          key: "column-".concat(columnName)
        }, t('uploaded_by'));
      case 'fileType':
        return /*#__PURE__*/React.createElement("th", {
          key: "column-".concat(columnName)
        }, t('Type'));
      case 'editButton':
        return /*#__PURE__*/React.createElement("th", {
          key: "column-".concat(columnName)
        });
      default:
        return /*#__PURE__*/React.createElement("div", {
          key: "column-".concat(columnName)
        }, columnName, " does not exist");
    }
  };
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, FILE_MANAGEMENT_COLUMN_ORDER.map(columnName => renderColumn(columnName))));
};
export default FolderAndFileTableHeading;